import React from 'react';
import {
	Wrapper,
	Title,
	Subtitle,
	HeaderLink,
} from 'holiday_hub/components/Content/styles';
import ArrowRight from 'core/icons/ArrowRight';
import BlogCard from './BlogCard';
import { filterCardsOnly, featuredContentProps } from 'core/utils';
import styled, { css } from 'styled-components';
import { typeScale, StyleVars } from 'core/utils';

const CardsWrapper = styled.div`
	padding: ${typeScale(3)} 0;
	display: grid;
	grid-gap: ${typeScale(3)};

	@media (min-width: 768px) {
		grid-gap: ${typeScale(5)};
	}

	@media (min-width: 1024px) {
		padding: ${typeScale(5)} 0;
	}

	${({ backgroundImage }) => backgroundImage && css`
		position: relative;
		&:before {
			content: '';
			display: block;
			z-index: -1;
			background: url(${backgroundImage}) no-repeat center 40px;
			background-size: 38%;

			position: absolute;
			top: 40px;
			bottom: 0;
			left: -100%;
			right: -100%;

			@media (max-width: ${StyleVars.screenSm}) {
				display: none;
			}
		}
	`}
`;

const LargeStackedCards = ({ title, subtitle, url, cta, content, backgroundImage, slug }) => (
	<Wrapper id={slug}>
		<Title centered>{title}</Title>
		{subtitle && <Subtitle centered>{subtitle}</Subtitle>}

		<CardsWrapper backgroundImage={backgroundImage}>
			{content.filter(filterCardsOnly).map((card, idx) => (
				<BlogCard
					key={`blog-${idx}`}
					{...card}
				/>
			))}
		</CardsWrapper>

		{url && cta && (
			<HeaderLink href={url} title={cta} centered>
				{cta}
				<ArrowRight fill="currentColor" />
			</HeaderLink>
		)}
	</Wrapper>
);

LargeStackedCards.propTypes = featuredContentProps;

LargeStackedCards.defaultProps = {};

export default LargeStackedCards;
